import { DataBean } from "../DataBean";

export class AssetItemsByOperationState extends DataBean {


    public async getFixedAssetItemsByOperationState(fixedAssetID:any,regex:any,idAccount:any,idStore:any,state:any,page:any,recordsPerPage:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getFixedAssetItemsByOperationState_Number_String_Number_Number_Number_Number_Number", [fixedAssetID,regex,idAccount,idStore,state,page,recordsPerPage]);
    }

}